import React from 'react';
import Shapes from './create_section/create_tools';
import Measure from './create_section/Measure';
import Reticles from './create_section/Reticles';
// import Duplicate from './create_section/Duplicate';
import Undo from './create_section/Undo';
import Clear from './create_section/Clear';
import Importing from './create_section/Importing';
import CanvasResizer from './create_section/CanvasResizer';

import './Tools.scss'

export default function Tools (props) {
   
        return (
            <nav className='tools_section' style={{ justifyContent: props.isSelectedCard ? 'center' : '' }}>
                {props.isSelectedCard && props.activeLink === '2' && props.activeLib === '1' ? (
                    <section className='clear-section'>
                        <button id='clearBtn' className='selectedBackBtn' onClick={() => props.handleChangeSelectedCardStatus('back')}>
                            <span className='clear_text'>Back</span>
                        </button>

                        <button id='clearBtn' className='delete-btn' onClick={() => props.handleDeleteSelectedReticles()}>
                            <span className='clear_text'>Delete</span>
                        </button>
                    </section>
                ) : null}

                {props.activeLink === '2' ? null : (
                    <>
                        <Shapes
                            instruments={props.instruments}
                            onSelectMove={props.onSelectChangeMove}
                            onSelectCircle={props.onSelectChangeCircle}
                            onSelectLine={props.onSelectChangeLine}
                            onSelectSimpleLine={props.onSelectChangeSimpleLine}
                        />
                        <Reticles
                            handlerReticleRename={props.handlerReticleRename}
                            focus={props.focus}
                            blur={props.blur}
                            activeTab={props.activeTab}
                        />
                        <section className='mesure_edit-section'>
                            <Measure
                                focusedInput={props.focusedInput}
                                onSelectRuler={props.onSelectRuler}
                                onSelectGrid={props.onSelectGrid}
                                onGetGridSize={props.onGetGridSize}
                                onExportPreviewData={props.onExportPreviewData}
                                gridSize={props.gridSize}
                                activeTab={props.activeTab}
                                focus={props.focus}
                                blur={props.blur}
                            />
                            <section className='command-btns_section'>
                                {/* <Duplicate duplicate={props.duplicate} /> */}
                                <Undo
                                    undo={props.undo}
                                    redo={props.redo}
                                />
                                <Clear clear={props.clear} toggleDeleteShape={props.toggleDeleteShape} />
                                <CanvasResizer/>
                            </section>
                            <Importing
                                onExportingTool={props.onExportingTool}
                                toggleModal={props.toggleModal}
                                getIsSavingId={props.getIsSavingId}
                                activeTab={props.activeTab}
                                handleImportReticleInfo={props.handleImportReticleInfo}
                                handlerAddTab={props.handlerAddTab}
                            />
                        </section>
                    </>
                )}
            </nav>
        )
}
